import InternalStaticAnchorContactList from 'models/application/anchor/types/internalStatic/types/ContactList';

export default class InternalStaticAnchorContactListService {
	toModel(anchor) {
		return new InternalStaticAnchorContactList(anchor);
	}
}
